import { makeStyles } from '@material-ui/core';
import { red, pink, purple, deepPurple, indigo, blue, lightBlue, cyan, teal, green, lightGreen, lime, yellow, amber, deepOrange } from '@material-ui/core/colors';

const useFormStyles = makeStyles((theme) => ({
  /* 
      - Some core styles
  */
  dBlock: {
    display: "block"
  },
  bold: {
    fontWeight: 600
  },
  w100: {
    width: "100%"
  },
  h100: {
    height: "100%"
  },
  // Accordion title styles
  accordionSubheader: {
    //color: brown[300],
    fontSize: 18
  },
  accordionTitle: {
    fontSize: 14
  },
  // Divider style
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  margin2: {
    margin: theme.spacing(2)
  },
  // Text field
  inputField: {
    padding: "7.875px 10.5px",
    fontSize: ".75rem",
    lineHeight: "inherit",
    "&::placeholder": {
      lineHeight: "inherit"
    }
  },
  // Expand button
  expandButton: {
    padding: "5px",
    marginRight: "-5px"
  },
  // Grey text
  greyText: {
    color: theme.palette.grey["500"]
  },
  formAccordion: {
    display: "flex"
  },
  chartsSemiTitle: {
    color: '#5A2B7E',
    marginTop: '20px'
  },
  chartBox: {
    width: "45%"
  },
  unitsTableContainer: {
    paddingBottom: "10px",
    paddingLeft: "10px"
  },
  unitsTableCell: {
    display: "inline-block !important",
    height: "37px",
    marginTop: "5px",
    padding: "0 5px 5px 0 !important",
    border: "0 !important"
  },
  colorColumn: {
    width: "60px"
  },
  unitTypeEditColumn: {
    width: "200px"
  },
  unitTypeEditSmallColumn: {
    width: "100px"
  },
  unitTypeNameColumn: {
    width: "120px"
  },
  floorAreaColumn: {
    width: "170px"
  },
  floorAreaSmallColumn: {
    width: "100px"
  },
  storeysColumn: {
    width: "90px"
  },
  houseWidthColumn: {
    width: "90px"
  },
  unitCostColumn: {
    width: "150px"
  },
  unitRevenueColumn: {
    width: "150px"
  },
  deleteIcon: {
    '&:hover': {
      cursor: "pointer"
    },
  },
  mypitem: {
    flex: "0 0 60%",
    marginRight: '3px'
  },
  mysitem: {
    flex: "1 0 15%",
    marginRight: '3px'
  },
  mytitem: {
    flex: "0 0 30px"
  }

}));

// A function which returns random colours
function getRandomColor() {
  const color = [red, pink, purple, deepPurple, indigo, blue, lightBlue, cyan, teal, green, lightGreen, lime, yellow, amber, deepOrange];

  const SHADES = ["200", "300", "400", "500", "600", "700", "800", "900", "A100", "A200", "A400", "A700"];

  // Return a random colour of a random shade

  return color[Math.floor(Math.random() * color.length)][SHADES[Math.floor(Math.random() * SHADES.length)]]
}

export { getRandomColor };

export default useFormStyles;